<body>
  <ngx-loading-bar [color]="'#F6F8FA'"></ngx-loading-bar>
  <app-nav-menu></app-nav-menu>
  <div class="container-fluid">
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  </div>
</body>
